import React from 'react'
import SliderImg from './SliderImg'

const Step3 = () => {
  return (
    <div className='step3'>
      <h2>Biggest WEB3 Priority - Community</h2>
      <div className='flex-row top'>
        <div className='t-img'><img src="images/steps/TwitterStats.jpg" alt="" /></div>
        <div className='d-img'><img src="images/steps/DiscordStats.jpg" alt="" /></div>
      </div>
      <SliderImg />
      <div className='bottom-line'>
        <p>Web3 Social Media Marketing | Community Building, Moderation (Twitter, Discord) | Team Management (Moderators)</p>
      </div>
    </div>

  )
}

export default Step3